//Built-in libraries

import ChevronDownIcon from '@heroicons/react/24/outline/ChevronDownIcon';
import { PlusCircleIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
//Third party libraries
import { useDispatch, useSelector } from 'react-redux';
import { sortAlphabetically } from '@/utils';
import { useWorkspaces } from '../../hooks/ReactQueryHooks/useWorkspaceQuery';
//Services
import { workspaceSelector } from '../../store';
import { setCurrentWorkspace } from '../../store/Workspace';
//Assets andd Miscellaneous
import type { IWorkspace } from '../../types/Workspace';
import { getCurrentLocalStorageWorkspace } from '../../utils/localstorage';
//Custom components
import SimpleDropDown from '../UI/SimpleDropDown';
import { WorkspaceItem } from './WorkspaceItem';

// import useEnvironment from '../../hooks/useEnvironment';

//Component Begin

interface IWorkspaceDropDownProps {
  handleAddWorkspace: () => void;
  handleEditWorkspace: (data: IWorkspace) => void;
}
export const WorkspaceDropdown = ({ handleAddWorkspace, handleEditWorkspace }: IWorkspaceDropDownProps) => {
  const dispatch = useDispatch();
  const { currentWorkspace } = useSelector(workspaceSelector);
  // const { isProd, isDev, isStage } = useEnvironment();
  const [showActiveWorkspaces, setShowActiveWorkspaces] = useState(true);

  const fetchWorkspaces = useWorkspaces({
    onSuccess: (data: IWorkspace[]) => {
      const localStorageWorkspace = getCurrentLocalStorageWorkspace();
      const currentWorkspaceObject = data?.find((workspace: IWorkspace) => workspace.id === localStorageWorkspace);
      dispatch(setCurrentWorkspace(currentWorkspaceObject));

      // if (isProd) {
      //   const currentWorkspaceObject = data?.find(
      //     (workspace: IWorkspace) => workspace.name === 'Default Workspace'
      //   );
      //   dispatch(setCurrentWorkspace(currentWorkspaceObject));
      // }
    },
    params: { archived: String(!showActiveWorkspaces) },
  });
  const workspaces: IWorkspace[] | undefined = [...(fetchWorkspaces?.data || [])].sort((a, b) => sortAlphabetically(a.name, b.name));

  return (
    <SimpleDropDown
      bigItem
      menuButtonClassName={
        'bg-white rounded-full flex justify-between items-center gap-2 text-sm border px-4 py-2 hover:bg-neutralColor-lightest truncate w-56'
      }
      itemContainerWidth='w-4/5'
      toggle={
        <>
          <span className='truncate' id='currentWorkspace'>
            {currentWorkspace?.name ? currentWorkspace?.name : 'All Programs'}
          </span>
          <ChevronDownIcon className='w-4 h-4' />
        </>
      }
    >
      <div className=' py-4 flex flex-col h-screen/80 overflow-y-auto' id='workspaceDropdownOptions'>
        <div
          className='sticky flex justify-between items-center gap-2 px-5 text-primaryColor cursor-pointer mb-2'
          role='button'
          onClick={handleAddWorkspace}
        >
          <h3 className='m-0 font-semibold'>Program</h3>
          <PlusCircleIcon className='w-6 h-6 hover:text-primaryColor-medium' />
        </div>
        <div className='px-3 border-b-2 pb-1.5 space-x-4'>
          <span
            className={`px-2 text-sm ${
              showActiveWorkspaces ? 'text-primaryColor-normal border-b-2 border-primaryColor-normal' : 'text-neutralColor-normal'
            } hover:text-primaryColor-normal cursor-pointer py-2`}
            id='active-workspaces'
            onClick={() => setShowActiveWorkspaces(true)}
          >
            Active
          </span>
          <span
            className={`px-2 text-sm ${
              !showActiveWorkspaces ? 'text-primaryColor-normal border-b-2 border-primaryColor-normal' : 'text-neutralColor-normal'
            } hover:text-primaryColor-normal cursor-pointer py-2`}
            id='archived-workspaces'
            onClick={() => setShowActiveWorkspaces(false)}
          >
            Archived
          </span>
        </div>

        <div className='flex-1 overflow-y-auto no-scrollbar'>
          {workspaces?.map((workspace: IWorkspace) => (
            <WorkspaceItem
              key={workspace.id ? workspace.id : workspace.name}
              workspace={workspace}
              onEdit={() => handleEditWorkspace(workspace)}
            />
          ))}
        </div>
      </div>
    </SimpleDropDown>
  );
};
